import service from './axios';

// 获取订单列表
export const fetchOrdersList = (params) => {
  return service({
    method: 'get',
    url: '/manage/orders',
    params
  });
};

// 获取订单详情
export const fetchOrderDetail = (id) => {
  return service({
    method: 'get',
    url: `/manage/orders/${id}`
  });
};

// 获取可用物流公司
export const getAvailableLogistics = (orderId) => {
  return service({
    method: 'get',
    url: `/manage/orders/${orderId}/logistics/available`
  });
};

// 发货
export const shipOrder = (id, data) => {
  return service({
    method: 'post',
    url: `/manage/orders/${id}/logistics/ship`,
    data
  });
};

// 处理退款
export const processRefund = (id, data) => {
  return service({
    method: 'post',
    url: `/manage/orders/${id}/process-refund`,
    data
  });
};

// 取消订单
export const cancelOrder = (id) => {
  return service({
    method: 'post',
    url: `/manage/orders/${id}/cancel`
  });
};

// 完成订单
export const completeOrder = (id) => {
  return service({
    method: 'post',
    url: `/manage/orders/${id}/complete`
  });
};

// 生成兑换码
export const generateCode = (id) => {
  return service({
    method: 'post',
    url: `/manage/orders/${id}/generate-code`
  });
};

// 获取物流节点信息
export const getLogisticsTracking = (orderId) => {
  return service({
    method: 'get',
    url: `/manage/orders/${orderId}/logistics/tracking`
  });
};
